import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import { Box, Text } from '@factorialco/deprecated-design-system'
import { type PermissionsGroupEmployeesPageItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'
import UserAvatar from 'modules/core/components/UserAvatar'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { BecomeModal } from 'modules/authentication/public'
import ChangeGroupModal from 'modules/permissions/components/ChangeGroupModal'

interface Props {
  user: PermissionsGroupEmployeesPageItemFragment
  canAssign: boolean
  onUpdate: () => void
}

const Item = ({ user, canAssign, onUpdate }: Props) => {
  const { navigation } = useNavigation()

  const [changeGroupModalOpen, setChangeGroupModalOpen] = React.useState(false)
  const [openBecome, toggleBecome] = React.useState(false)
  const [open, toggle] = useToggle(false)

  const options = (): Option[] => {
    const allowedOptions = []

    if (canAssign) {
      allowedOptions.push({
        title: i18n.t('settings.permissions.group.change_group'),
        onClick: () => {
          setChangeGroupModalOpen(true)
        },
      })
    }

    if (user._policies?.become?.can ?? false) {
      allowedOptions.push({
        title: i18n.t('employees.become.action', { name: user.firstName }),
        onClick: () => {
          toggleBecome(true)
        },
      })
    }

    return allowedOptions
  }

  return (
    <Box
      width="full"
      flexDirection="row"
      padding="s16"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey200',
        },
      }}
      alignItems="center"
    >
      <Box width="full" flexDirection="row" gap="s16" alignItems="center">
        <UserAvatar user={user} />
        <Box width="full">
          <Text size="400" weight="normal" color="grey1000">
            {user.fullName}
          </Text>
          <Text size="300" weight="normal" color="grey600">
            {user.employee?.referenceContract?.jobTitle}
          </Text>
        </Box>
      </Box>
      <Box flexDirection="row" gap="s4" alignItems="center">
        {options().length > 0 && (
          <Popover
            attachment="top right"
            targetAttachment="bottom center"
            toggle={toggle}
            open={open}
          >
            <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
            <PopoverContent onClose={toggle(false)} options={options()} />
          </Popover>
        )}
        {user.employee && (
          <Button.Router
            to={navigation.employees.id.fullPath({ id: user.employee.id })}
            type="secondary"
            iconName="arrow-right"
          />
        )}
      </Box>
      {openBecome && (
        <BecomeModal
          accessId={user.id}
          firstName={user.firstName}
          onClose={() => toggleBecome(false)}
        />
      )}
      {changeGroupModalOpen && (
        <ChangeGroupModal
          userId={user.id}
          onClose={() => {
            setChangeGroupModalOpen(false)
            onUpdate()
          }}
        />
      )}
    </Box>
  )
}

export default observer(Item)
